import { render, staticRenderFns } from "./miniHours.vue?vue&type=template&id=605c8858&"
import script from "./miniHours.vue?vue&type=script&lang=js&"
export * from "./miniHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports